/* @src/pre-deployment/src/tracking/silentTrack.js */
// Conditionally import pushLog - only available in browser (React component)
let pushLog = () => {}; // Default no-op for Node.js
if (typeof window !== 'undefined') {
    import('../components/shared/ConsoleOverlay.js').then(module => {
        pushLog = module.pushLog;
    }).catch(() => {});
}

export const silentTrack = async (fn, context = 'tracking') => {
    try {
        pushLog(`📡 Tracking Start: ${context}`, 'info', 'tracking');
        const result = await fn();
        pushLog(`✅ Tracking Success: ${context}`, 'success', 'tracking');
        return result;
    } catch (error) {
        pushLog(`❌ Tracking Error (${context}): ${error.message}`, 'error', 'tracking');
        console.error(`❌ Error sending data (${context}):`, error);
        console.warn('⚠️ Tracking failed but app continues normally');
        return null;
    }
};
